import React, { useEffect, useState, useRef } from 'react';
import { history } from 'umi';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';
import dayjs from 'dayjs';
import request from '@/utils/request';
import { OPT_DETAIL } from '@/constants.js';
import { fmtThousand } from '@/utils/comUtil';
import StepML from './components/StepML';
import BaseInfoML from './components/BaseInfoML/BaseInfoML';
import PrizeML from './components/PrizeML/PrizeML';
import StyleML from './components/StyleML/StyleML';
import Styled from './styles';

const typeArr = {
  EXCHANGE_COUPON: '4',
  DISCOUNT_COUPON: '1',
  CASH_COUPON: '2',
  FULL_DISCOUNT_COUPON: '3',
  THIRD_PARTY_COUPON: '11',
  FREE_TICKET_COUPON: '9',
  GIFT_COUPON: '10',
};
const typeArrDetail = {
  4: 'EXCHANGE_COUPON',
  1: 'DISCOUNT_COUPON',
  2: 'CASH_COUPON',
  3: 'FULL_DISCOUNT_COUPON',
  11: 'THIRD_PARTY_COUPON',
  9: 'FREE_TICKET_COUPON',
  10: 'GIFT_COUPON',
};
export default () => {
  const {
    opt: queryType,
    id,
    sourceOid,
    campaignStatus: status,
  } = history.location?.query;

  const [openDialog, setOpenDialog] = useState();
  const [step, setStep] = useState(1);
  const [defaultValuesData, setDefaultValuesData] = useState();
  const [saveData, setSaveData] = useState();
  const [formStatus, setFormStatus] = useState({
    1: 'underway',
    2: 'underway',
    3: 'underway',
  });
  const saveRef = useRef();
  const [isNext, setIsNext] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const onSetStep = (n) => {
    setStep(n);
    setFormStatus({ ...formStatus, [n]: 'underway' });
  };

  const handleSubmitSuccessBase = (values) => {
    setFormStatus({ ...formStatus, [step]: 'done' });
    setSaveData({ ...saveData, ...values });
    setStep((n) => n + 1);
  };
  const handleSubmitFailBase = () => {
    setFormStatus({ ...formStatus, [step]: 'underway' });
  };
  const handleSubmitSuccessPrize = (values) => {
    setFormStatus({ ...formStatus, [step]: 'done' });
    setSaveData({ ...saveData, ...values });
    if (!isNext) {
      setStep((n) => n - 1);
    } else {
      setStep((n) => n + 1);
    }
    setIsNext(false);
  };
  const handleSubmitFailPrize = () => {
    setFormStatus({ ...formStatus, [step]: 'underway' });
    setIsNext(false);
  };
  //点击退出
  const handleExitClick = () => {
    if (queryType === OPT_DETAIL) {
      return history.goBack();
    }
    setOpenDialog(true);
  };

  const handleSubmitSuccessStyle = (values) => {
    try {
      if (isSubmit) {
        return;
      }
      setIsSubmit(true);
      setFormStatus({ ...formStatus, [step]: 'done' });
      const allValue = { ...saveData, ...values };
      if (!isNext) {
        setIsSubmit(false);
        setSaveData(allValue);
        setStep((n) => n - 1);
      } else {
        //点击完成按钮
        let key =
          allValue.type === 'SLYDER_ADVENTURES'
            ? 'wheel'
            : allValue.type === 'SUDOKU'
            ? 'sudoku'
            : allValue.type === 'SCRATCH_CARD'
            ? 'scratch'
            : 'shake';
        const images = {
          [key]: {
            backgroundPicUrl: allValue.backgroundPicUrl[0],
            startBtnPicUrl: allValue.startBtnPicUrl[0],
          },
        };
        allValue.images = images;
        allValue.beginDateTime = allValue.date.startDate + ' 00:00:00';
        allValue.endDateTime = allValue.date.endDate + ' 23:59:59';
        allValue.prizeModel.forEach((i) => {
          i.point = i.point
            ? i.point?.toString()?.replace(/,/g, '') || null
            : null;
          if (i.coupons) {
            i.couponId = i.coupons.id;
            i.coupons = {
              ...i.coupons,
              couponId: i.coupons.id,
              couponName: i.coupons.title,
              couponType: typeArr[i.coupons.typeName],
            };
          } else {
            i.coupons = null;
          }
        });

        allValue.prizeModel = [
          ...allValue.prizeModel,
          {
            title: allValue.noPrizeTitle,
            notice: allValue.notice,
            prizeId: allValue.noPrizeId,
            type: 'NO_PRIZE',
          },
        ];
        const miniProgramPage = {
          title: allValue.miniTitle,
          pagePath: allValue.pagePath,
          thumbUrl: allValue.thumbUrl ? allValue.thumbUrl[0] : null,
        };

        allValue.miniProgramPage = miniProgramPage;
        allValue.completeInfoDrawNum = allValue.isCompleteInfoDrawEnabled
          ? allValue.completeInfoDrawNum?.replace(/,/g, '') || null
          : null;
        allValue.studentAuthDrawNum = allValue.isStudentAuthDrawEnabled
          ? allValue?.studentAuthDrawNum?.toString()?.replace(/,/g, '') || null
          : null;
        allValue.studentAuthMaxDrawNum = allValue.isStudentAuthDrawEnabled
          ? allValue?.studentAuthMaxDrawNum?.toString()?.replace(/,/g, '') ||
            null
          : null;
        allValue.orderDrawNum = allValue.isOrderDrawEnabled
          ? allValue?.orderDrawNum?.toString()?.replace(/,/g, '') || null
          : null;
        allValue.orderMaxDrawNum = allValue.isOrderDrawEnabled
          ? allValue.orderMaxDrawNum?.toString()?.replace(/,/g, '') || null
          : null;
        allValue.dailyDrawNum = allValue.dailyDrawNumCheck
          ? allValue.dailyDrawNum?.toString()?.replace(/,/g, '') || null
          : null;
        allValue.exchangePoint = allValue.isExchangeDrawNum
          ? allValue.exchangePoint?.toString()?.replace(/,/g, '') || null
          : null;
        allValue.isExchangeDrawNum = allValue.isExchangeDrawNum
          ? allValue.isExchangeDrawNum?.toString()?.replace(/,/g, '') || null
          : null;
        allValue.shareRegisterDrawNum = allValue.isRegisterDrawNum
          ? allValue.shareRegisterDrawNum?.toString()?.replace(/,/g, '') || null
          : null;
        allValue.shareRegisterDayMaxDrawNum = allValue.isRegisterDrawNum
          ? allValue.shareRegisterDayMaxDrawNum
              ?.toString()
              ?.replace(/,/g, '') || null
          : null;
        allValue.registerDrawNum = allValue.isRegister
          ? allValue.registerDrawNum?.toString()?.replace(/,/g, '') || null
          : null;
        allValue.registerBeginDateTime = allValue.isRegister
          ? dayjs(allValue.dateReg.startDate).format('YYYY-MM-DD 00:00:00')
          : null;
        allValue.registerEndDateTime = allValue.isRegister
          ? dayjs(allValue.dateReg.endDate).format('YYYY-MM-DD 23:59:59')
          : null;
        allValue.drawNumLimit = allValue.drawNumLimitCheck
          ? allValue.drawNumLimit?.toString()?.replace(/,/g, '') || null
          : null;
        allValue.winLimit = allValue.winLimitCheck
          ? allValue.winLimit?.toString()?.replace(/,/g, '') || null
          : null;
        allValue.dailyWinLimit = allValue.dailyWinLimitCheck
          ? allValue.dailyWinLimit?.toString()?.replace(/,/g, '') || null
          : null;
        allValue.dailyDrawLimit = allValue.dailyDrawLimitCheck
          ? allValue.dailyDrawLimit?.toString()?.replace(/,/g, '') || null
          : null;

        let url = id
          ? '/activityLottery/updateActivityLottery'
          : '/activityLottery/addActivityLottery';
        request(url, {
          method: 'POST',
          data: { ...allValue, id },
        })
          .then((res) => {
            window.NE_DAWN.trigger(saveRef.current, {
              event: '_ec', // 事件名
              params: { ...allValue, id }, // 事件公参
            });
            if (res?.code === 0) {
              console.log('保存成功');
              window.message.toast({
                type: 'success',
                message: '礼品保存成功',
                title: '保存成功',
              });
              setTimeout(() => {
                history.goBack();
              });
            } else {
              console.log('保存失败');
            }
            setIsSubmit(false);
          })
          .catch(() => {
            setIsSubmit(false);
          });
      }
      setIsNext(false);
    } catch {
      setIsNext(false);
      setIsSubmit(false);
    }
  };
  const handleSubmitFailStyle = () => {
    setIsNext(false);
    setFormStatus({ ...formStatus, [step]: 'underway' });
  };

  useEffect(() => {
    const fun = async () => {
      const res = await request('/activityLottery/queryActivityDetail', {
        method: 'POST',
        data: { id },
      });
      if (res.code === 0) {
        const data = res.data;
        let wheel = data.images.wheel || {};
        if (data.type === 'SUDOKU') {
          wheel = data.images.sudoku || {};
        } else if (data.type === 'SCRATCH_CARD') {
          wheel = data.images.scratch || {};
        } else if (data.type === 'SHAKE_IT_OFF') {
          wheel = data.images.shake || {};
        }
        const backgroundPicUrl = [wheel.backgroundPicUrl];
        const startBtnPicUrl = [wheel.startBtnPicUrl];
        const date = {
          startDate: dayjs(data.beginDateTime).format('YYYY-MM-DD'),
          endDate: dayjs(data.endDateTime).format('YYYY-MM-DD'),
        };
        const checkPrizeNumRes = await request(
          '/activityLottery/queryPrizeSendNum',
          {
            method: 'POST',
            data: {
              id,
            },
          },
        );
        // remainingQuantity
        const prizeModel = data.prizeModel.filter((i) => i.type !== 'NO_PRIZE');
        prizeModel.forEach((x, index) => {
          const remainingQuantity = checkPrizeNumRes.data.find(
            (i) => i.prizeId === x.prizeId,
          ).stock;
          x.id = `prize_${Date.now() + index}`;
          x.point = x.point ? fmtThousand(Number(x.point), 2, true) : '';
          x.remainingQuantity = remainingQuantity;
          if (x.coupons) {
            x.coupons = {
              ...x.coupons,
              id: x.coupons.couponId,
              title: x.coupons.couponName,
              couponType: typeArrDetail[x.coupons.couponType],
            };
          }
        });
        const noPrizeTitle =
          data.prizeModel.find((i) => i.type === 'NO_PRIZE')?.title || '';
        const notice =
          data.prizeModel.find((i) => i.type === 'NO_PRIZE')?.notice || '';
        const noPrizeId =
          data.prizeModel.find((i) => i.type === 'NO_PRIZE')?.prizeId || '';
        const miniTitle = data.miniProgramPage.title;
        const pagePath = data.miniProgramPage.pagePath;
        const thumbUrl = data.miniProgramPage?.thumbUrl
          ? [data.miniProgramPage?.thumbUrl]
          : [];
        const isCompleteInfoDrawEnabled = Boolean(data.completeInfoDrawNum);
        const isStudentAuthDrawEnabled = Boolean(data.studentAuthDrawNum);
        const isOrderDrawEnabled = Boolean(data.orderDrawNum);
        const dailyDrawNumCheck = Boolean(data.dailyDrawNum);
        const isExchangeDrawNum = Boolean(data.exchangePoint);
        const isRegisterDrawNum = Boolean(data.shareRegisterDrawNum);
        const drawNumLimitCheck = Boolean(data.drawNumLimit);
        const winLimitCheck = Boolean(data.winLimit);
        const dailyWinLimitCheck = Boolean(data.dailyWinLimit);
        const dailyDrawLimitCheck = Boolean(data.dailyDrawLimit);
        const isRegister = Boolean(data.registerDrawNum);
        const completeInfoDrawNum = data.completeInfoDrawNum
          ? fmtThousand(Number(data.completeInfoDrawNum), 2, true)
          : '';
        const studentAuthDrawNum = data.studentAuthDrawNum
          ? fmtThousand(Number(data.studentAuthDrawNum), 2, true)
          : '';
        const studentAuthMaxDrawNum = data.studentAuthMaxDrawNum
          ? fmtThousand(Number(data.studentAuthMaxDrawNum), 2, true)
          : '';
        const orderDrawNum = data.orderDrawNum
          ? fmtThousand(Number(data.orderDrawNum), 2, true)
          : '';
        const orderMaxDrawNum = data.orderMaxDrawNum
          ? fmtThousand(Number(data.orderMaxDrawNum), 2, true)
          : '';
        const dailyDrawNum = data.dailyDrawNum
          ? fmtThousand(Number(data.dailyDrawNum), 2, true)
          : '';
        const exchangePoint = data.exchangePoint
          ? fmtThousand(Number(data.exchangePoint), 2, true)
          : '';
        const shareRegisterDrawNum = data.shareRegisterDrawNum
          ? fmtThousand(Number(data.shareRegisterDrawNum), 2, true)
          : '';
        const shareRegisterDayMaxDrawNum = data.shareRegisterDayMaxDrawNum
          ? fmtThousand(Number(data.shareRegisterDayMaxDrawNum), 2, true)
          : '';
        const registerDrawNum = data.registerDrawNum
          ? fmtThousand(Number(data.registerDrawNum), 2, true)
          : '';
        const drawNumLimit = data.drawNumLimit
          ? fmtThousand(Number(data.drawNumLimit), 2, true)
          : '';
        const winLimit = data.winLimit
          ? fmtThousand(Number(data.winLimit), 2, true)
          : '';
        const dailyWinLimit = data.dailyWinLimit
          ? fmtThousand(Number(data.dailyWinLimit), 2, true)
          : '';
        const dailyDrawLimit = data.dailyDrawLimit
          ? fmtThousand(Number(data.dailyDrawLimit), 2, true)
          : '';
        const dateReg = {
          startDate: data.registerBeginDateTime || data.beginDateTime,
          endDate: data.registerEndDateTime || data.endDateTime,
        };
        const allData = {
          ...res.data,
          completeInfoDrawNum,
          studentAuthDrawNum,
          studentAuthMaxDrawNum,
          orderDrawNum,
          orderMaxDrawNum,
          dailyDrawNum,
          exchangePoint,
          isExchangeDrawNum,
          isRegister,
          dateReg,
          shareRegisterDrawNum,
          shareRegisterDayMaxDrawNum,
          registerDrawNum,
          drawNumLimit,
          winLimit,
          dailyWinLimit,
          dailyDrawLimit,
          backgroundPicUrl,
          startBtnPicUrl,
          date,
          prizeModel,
          noPrizeTitle,
          notice,
          noPrizeId,
          miniTitle,
          pagePath,
          thumbUrl,
          isCompleteInfoDrawEnabled,
          isStudentAuthDrawEnabled,
          isOrderDrawEnabled,
          dailyDrawNumCheck,
          isRegisterDrawNum,
          drawNumLimitCheck,
          winLimitCheck,
          dailyWinLimitCheck,
          dailyDrawLimitCheck,
        };

        setDefaultValuesData(allData);
        setSaveData(allData);
      }
    };
    if (id) {
      setFormStatus({
        1: 'done',
        2: 'done',
        3: 'done',
      });
      fun();
    }
  }, [id]);
  return (
    <>
      <Styled
        data-log={JSON.stringify({
          oid: 'page_marketing_activity_lottery_edit',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
            source: sourceOid,
          },
          events: ['_pv', '_pd'],
        })}
        className="form-wrap-paper"
      >
        <StepML formStatus={formStatus} step={step} onSetStep={onSetStep} />
        <div
          style={{ display: step === 1 ? 'block' : 'none', overflow: 'hidden' }}
        >
          <BaseInfoML
            queryType={queryType}
            id={id}
            status={status}
            formStatus={formStatus}
            setFormStatus={setFormStatus}
            defaultValuesData={defaultValuesData}
            handleExitClick={handleExitClick}
            handleSubmitSuccessBase={handleSubmitSuccessBase}
            handleSubmitFailBase={handleSubmitFailBase}
          />
        </div>
        <div
          style={{ display: step === 2 ? 'block' : 'none', overflow: 'hidden' }}
        >
          <PrizeML
            queryType={queryType}
            id={id}
            status={status}
            step={step}
            isNext={isNext}
            setIsNext={setIsNext}
            defaultValuesData={defaultValuesData}
            handleExitClick={handleExitClick}
            handleSubmitSuccessPrize={handleSubmitSuccessPrize}
            handleSubmitFailPrize={handleSubmitFailPrize}
          />
        </div>
        <div
          style={{ display: step === 3 ? 'block' : 'none', overflow: 'hidden' }}
        >
          <StyleML
            queryType={queryType}
            step={step}
            isNext={isNext}
            setIsNext={setIsNext}
            saveData={saveData}
            id={id}
            status={status}
            saveRef={saveRef}
            defaultValuesData={defaultValuesData}
            handleExitClick={handleExitClick}
            handleSubmitSuccessStyle={handleSubmitSuccessStyle}
            handleSubmitFailStyle={handleSubmitFailStyle}
          />
        </div>
      </Styled>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ minWidth: '200px' }}
          >
            {queryType !== 'detail'
              ? '退出后将不保存设置内容，确定要退出吗？'
              : '确定要退出吗？'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={() => {
              setOpenDialog(false);
            }}
          >
            取消
          </Button>
          <Button
            variant="text"
            sx={{ width: '57px' }}
            onClick={() => {
              setOpenDialog(false);
              history.goBack();
            }}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
